<template>
  <modal
    style="modal"
    name="sarsCoV-modal"
    height="auto"
    :adaptive="true"
    :pivot-y="0.5"
    :width="modalWidth"
    :maxWidth="500"
    :clickToClose="true"
  >
    <div class="box">
      <div class="img-Container">
        <img :src="getImage" alt="" />
      </div>
      <hr class="seperator" />
      <div class="infoText">
        <span>{{ $t("sars_cov_pop_up") }}</span>
        <button class="closeBtn" @click="closeModal">
          {{ $t("close") }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "SarsCoVModalPopUp",
  computed: {
    getImage() {
      return this.$store.getters.image_sars_cov_ies;
    },
    modalWidth() {
      if (window.innerWidth <= 575) {
        return "100%";
      } else {
        return "90%";
      }
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide("sarsCoV-modal");
    }
  }
};
</script>

<style scoped>
.img-Container {
  padding: 16px;
}
.box {
  background: white;
  flex-shrink: initial;
  flex-direction: column;
  position: relative;
}
.seperator {
  width: 110%;
  margin: 0px;
  border: 1px solid #dee2e6;
}
.infoText {
  display: flex;
  padding: 16px;
  font-size: 100%;
  flex-direction: row;
}
.closeBtn {
  min-width: 90px;
  color: white;
  height: 38px;
  margin-left: 5px;
  background-color: #6c757d;
  border-radius: 3px;
  align-self: center;
}
</style>
